/**
 * Everything that makes this app *this* app, in one file. Imported by
 * `vite.config.ts` too, so it stays free of DOM and Node APIs.
 */
export const APP = {
  name: 'Điểm danh Ca đoàn',
  /** Home-screen label. iOS truncates past ~12 characters. */
  shortName: 'Ca đoàn',
  description: 'Điểm danh ca đoàn trên điện thoại, dùng được cả khi mất mạng.',
  /** Browser chrome colour: the page's own white, so the status bar reads as page. */
  themeColor: '#ffffff',
  /** Splash background; must match `--color-bg` (light) in tokens.css. */
  backgroundColor: '#ffffff',
  /** Namespaces every localStorage key. */
  storagePrefix: 'cadoan_v1',
  /** IndexedDB name. Changing it after ship orphans every phone's offline data. */
  dbName: 'cadoan_gt',
  defaultLocale: 'vi',
} as const

/** `cadoan_v1_foo` — the only way a storage key should ever be built. */
export const storageKey = (name: string) => `${APP.storagePrefix}_${name}`

/**
 * Where the API lives. Empty in development: Vite proxies `/api` to the local
 * Worker. In production the Pages build sets `VITE_API_BASE` to the Worker URL.
 */
export const API_BASE: string = import.meta.env?.VITE_API_BASE ?? ''
